
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { DeviceInfo } from '@/types/device-info';
import { HistoryData } from '@/types/history';
import MapControl from '@/components/history/MapControl.vue';
import api from '@/modules/api';
import _get from 'lodash.get';
import LoadableMixin from '@/mixins/LoadableMixin';
import { DEVICE_HISTORY_UPDATE } from '@/constants/eventTypes';

@Component({
    mixins: [LoadableMixin],
    components: {
        MapControl,
    },
})
export default class DeviceHistoryMap extends Mixins<LoadableMixin>(LoadableMixin) {
    dialog = false;
    protected popupMapStyles = '';
    locations: HistoryData[] = [];
    perPage = 10;
    perPageOptions = [
        {
            text: '10',
            value: 10,
        },
        {
            text: '20',
            value: 20,
        },
        {
            text: '30',
            value: 30,
        },
        {
            text: '40',
            value: 40,
        },
        {
            text: '50',
            value: 50,
        },
        {
            text: '75',
            value: 75,
        },
        {
            text: '100',
            value: 100,
        },
    ];
    protected mapInitialized = false;

    @Prop({ required: true })
    device!: DeviceInfo;

    // @Prop({ required: true })
    // getAddress!: (lat: number, long: number) => string;

    @Prop({ default: false })
    expandable!: boolean;

    @Prop({ required: true })
    historyViewType!: string;

    expand() {
        this.dialog = true;

        setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this.$refs.dialogMap as any).$refs.lmap.mapObject.invalidateSize();
        }, 50);
    }

    updateMapHistory(event: any) {
        const lastLocation: HistoryData = {
            latitude: event.detail.latitude,
            longitude: event.detail.longitude,
            timeCreated: event.detail.timeCreated,
            type: event.detail.type ?? null,
            address: event.detail.address,
            modem_temperature: event.detail.modem_temperature ?? null,
            modem_voltage: event.detail.modem_voltage ?? null,
            isLocked: false,
            unlockType: 0,
        };

        const prev = [...this.locations];

        // if prev is empty => insert
        if (prev.length === 0) {
            prev.push(lastLocation);
            this.locations = prev;
            return;
        }

        // if updated => insert at top and remove last index
        const prevLocation = prev[0];
        if (
            (prevLocation.latitude != lastLocation.latitude || prevLocation.longitude != lastLocation.longitude) &&
            (prevLocation.address == 'N/A' ||
                lastLocation.address == 'N/A' ||
                prevLocation.address != lastLocation.address)
        ) {
            prev.unshift(lastLocation);
            if (prev.length > this.perPage) prev.pop();
            this.locations = prev;
            return;
        }

        // if same => update timestamp
        prev[0].timeCreated = lastLocation.timeCreated;
        this.locations = prev;

        // const prevLocation = prev[prev.length - 1];
        // if (
        //     prev.length === 0 ||
        //     ((prevLocation.latitude != lastLocation.latitude || prevLocation.longitude != lastLocation.longitude) &&
        //         (prevLocation.address == 'N/A' ||
        //             lastLocation.address == 'N/A' ||
        //             prevLocation.address != lastLocation.address))
        // ) {
        //     console.log(
        //         `imei: ${event.detail?.imei}, Latitude: ${lastLocation.latitude}, Longitude: ${lastLocation.longitude}, address: ${lastLocation.address}, type: ${lastLocation.type}`,
        //     );

        //     prev.push(lastLocation);
        //     if (prev.length > this.perPage) prev.shift();
        //     this.locations = prev;
        // }
    }

    mounted() {
        window.addEventListener(DEVICE_HISTORY_UPDATE, this.updateMapHistory);
    }

    destroyed() {
        window.removeEventListener(DEVICE_HISTORY_UPDATE, this.updateMapHistory);
    }

    async fetchLocation(device?: DeviceInfo) {
        device = device || this.device;
        if (!device) return;
        this.setLoading(true);
        try {
            const response = await api.getHistoryForMap(device.deviceUUID, { perPage: this.perPage });

            this.locations = response;
        } catch (error) {
            this.$toasted.error(`Unable to load history for device ${device.name}`);
        } finally {
            this.setLoading(false);
        }
    }

    @Watch('device', { immediate: true, deep: true })
    async onDeviceChange(device: DeviceInfo, prevDevice: DeviceInfo) {
        if (_get(device, '_id') !== _get(prevDevice, '_id')) {
            this.fetchLocation(device);
            this.mapInitialized = true;
        }
    }

    @Watch('perPage')
    async onPerPageChange() {
        if (this.mapInitialized) this.fetchLocation(this.device);
    }
}
